export const MIN_OPTIONS = 5;
export const OPTION_HEIGHT = 100;
